import {
  OEText as OETextBase,
  OEText,
  maxHeight,
  mt,
  overflow,
  width,
  mb,
  ml,
  flex,
  useModal,
  CircleIcon,
} from '@openeducation/oe-it-components';
import type { FeedbackResponseDTO } from '@openeducation/oe-it-services';
import { styled } from '@openeducation/oe-it-themes';
import React, { useRef, useState } from 'react';
import { LayoutChangeEvent, TouchableOpacity, View } from 'react-native';

import FeedbackContentModal from '../feedback-content-modal/feedback-content-modal';

const MAX_FEEDBACK_HEIGHT = 85;
export const noFeedbackText =
  'The teacher is working on completing the feedback';
export interface PCFeedbackCardCommentProps {
  feedback: FeedbackResponseDTO;
}

export const PCFeedbackCardComment = ({
  feedback,
}: PCFeedbackCardCommentProps) => {
  const { openModal, closeModal } = useModal();
  const [readMore, setReadMore] = useState(false);
  const refComment = useRef<View>(null);
  const { teacherFeedback } = feedback;

  const handleLayoutContent = ({
    nativeEvent: {
      layout: { height },
    },
  }: LayoutChangeEvent) => {
    setReadMore(height === MAX_FEEDBACK_HEIGHT);
  };
  const renderContent = () => {
    if (teacherFeedback.length === 0) {
      return (
        <View style={[mt(30), mb(40), flex('flex-row', 'align-items-center')]}>
          <CircleIcon name="file" size={48} />
          <View style={[flex('flex-1'), ml(16)]}>
            <OEText fontSize={16}>{noFeedbackText}</OEText>
          </View>
        </View>
      );
    }

    return <FeedbackText>{teacherFeedback}</FeedbackText>;
  };

  return (
    <View style={[width(569), mt(16)]}>
      <View
        style={[maxHeight(100), overflow('hidden')]}
        onLayout={handleLayoutContent}
        ref={refComment}
      >
        {renderContent()}
      </View>

      {teacherFeedback.length > 0 && readMore && (
        <TouchableOpacity
          onPress={() =>
            openModal(
              <FeedbackContentModal
                feedback={feedback}
                onGotItPress={closeModal}
              />
            )
          }
        >
          <ReadMoreLink>Read more »</ReadMoreLink>
        </TouchableOpacity>
      )}
    </View>
  );
};

const FeedbackText = styled(OETextBase).attrs(({ theme }) => ({
  fontFamily: theme.secondaryFont,
}))`
  font-size: 16px;
  max-height: ${MAX_FEEDBACK_HEIGHT}px;
`;

const ReadMoreLink = styled(OETextBase).attrs(({ theme }) => ({
  color: theme.color.accent,
  fontFamily: theme.secondaryFont,
  fontType: 'italic',
}))``;
